import { Grid, Link } from '@mui/material'
import { styled } from '@mui/material/styles'

export const StyledDropdownItem = styled(Grid)`
  height: 100%;

  &:hover {
    cursor: pointer;
  }

  &:hover::after {
    opacity: 1;
    width: 100%;
  }

  &:focus::after {
    opacity: 1;
    width: 100%;
  }
`

export const StyledItemLink = styled(Link)`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
  color: ${(props) => props.theme.palette.text.primary};
  text-decoration: none;
  aria-haspopup="menu"
`

export const StyledTarget = styled('span')`
  position: absolute;
  z-index: ${(props) => props.theme.zIndex.appBar + 1};
  pointer-events: none;
  border-bottom: 3px solid ${(props) => props.theme.palette.secondary.main};
  border-radius: 3px;
  transform: scaleX(0);
  bottom: 0;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out, width 0.3s ease-in-out, left 0.3s ease-in-out;
`

export const StyledPanelWrapper = styled(Grid)`
  overflow: auto;
  position: relative;
`
